/* GW PDP gallery — Figma 30:10669 (desktop 640 x 745) / 30:10024 (mobile
   361 x 381).

   The frame's thumbnail strip is five equal thumbs between two chevrons:
   640 - 12 - 12 - 6x16 = 520, / 5 = 104 wide on desktop; 361 - 16 - 16 - 6x8
   = 281, / 5 = 56.2 on mobile. Everything else in the gallery — the column
   gap, the main image ratio, the row height, the chevron glyphs — is in
   assets/section-gw-pdp.min.css. This file exists for the one value CSS
   cannot own.

   Swiper writes each slide's width inline from slidesPerView, and the theme
   derives that from the section's image_size: 5.5 / 6.5 / 7.5 for small /
   medium / large (assets/component-product-media.js:18704-18710). No schema
   setting reaches it without also resizing the media column — image_size
   drives both, and the column drops from 638 to 531.6 against the frame's
   640. So the live instance is reconfigured instead: params are changed and
   update() recomputes the transform maths from them. Overriding the slide
   width in CSS would leave Swiper paging to coordinates it no longer draws.

   The theme re-initialises the gallery on variant change and on section
   reload, so the observer stays for the life of the page and the
   shopify:section:load handler covers the theme editor.
*/

const STRIP = '.thumbnail-media--thumbnails';

/* Figma 30:10671 / 30:10026 — five per view at both breakpoints, the gap
   stepping 16 -> 8 below the theme's 1025 desktop breakpoint. */
const PER_VIEW = 5;
const GAP_MOBILE = 8;
const GAP_DESKTOP = 16;

function configure(strip) {
  const swiper = strip.swiper;
  if (!swiper || swiper.destroyed) return false;

  const gap = window.matchMedia('(min-width: 1025px)').matches ? GAP_DESKTOP : GAP_MOBILE;
  if (swiper.params.slidesPerView === PER_VIEW && swiper.params.spaceBetween === gap) return true;

  /* Both breakpoints are declared, including the 0 one. setBreakpoint()
     restores everything outside the ACTIVE breakpoint entry from
     swiper.originalParams, so params set directly were reverted the moment
     Swiper next recalculated — below 1025 they lasted one frame.
     originalParams is updated too, for the rebuild path. */
  const breakpoints = {
    0: { slidesPerView: PER_VIEW, spaceBetween: GAP_MOBILE },
    1025: { slidesPerView: PER_VIEW, spaceBetween: GAP_DESKTOP },
  };

  swiper.params.breakpoints = breakpoints;
  if (swiper.originalParams) {
    swiper.originalParams.breakpoints = breakpoints;
    swiper.originalParams.slidesPerView = PER_VIEW;
    swiper.originalParams.spaceBetween = GAP_MOBILE;
  }

  /* Swiper only re-reads breakpoints when it thinks the breakpoint changed. */
  swiper.currentBreakpoint = null;
  if (typeof swiper.setBreakpoint === 'function') swiper.setBreakpoint();
  swiper.update();

  return true;
}

/* The theme builds the Swiper long after DOMContentLoaded — this page carries
   three apps and the gallery waits on its images — and DESTROYS and rebuilds
   it when the viewport crosses its own 1025 breakpoint, which restores the
   theme's own slidesPerView. A one-shot configure therefore either runs too
   early or is undone later, so the strips are re-checked on a cheap ticker:
   configure() is a two-value comparison once the params are ours. */
function watch(strip) {
  if (strip.dataset.gwGallery !== 'watching') {
    strip.dataset.gwGallery = 'watching';
    new MutationObserver(() => configure(strip)).observe(strip, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
  configure(strip);
}

function scan(root) {
  if (!root || root.nodeType !== 1) return;
  if (root.matches && root.matches(STRIP)) watch(root);
  if (root.querySelectorAll) root.querySelectorAll(STRIP).forEach(watch);
}

scan(document.body);

/* 250ms x 1200 = five minutes, then the class observer alone carries it. */
let ticks = 0;
const ticker = setInterval(() => {
  scan(document.body);
  if (++ticks > 1200) clearInterval(ticker);
}, 250);

new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach(scan));
}).observe(document.body, { subtree: true, childList: true });

document.addEventListener('shopify:section:load', (event) => scan(event.target));

window.matchMedia('(min-width: 1025px)').addEventListener('change', () => scan(document.body));
